import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-line"></div>
        <h2>Thank You for Choosing Us</h2>
        <p>We’re honored to be part of your dining experience.</p>
      </div>
    </footer>
  );
}
